import { createSlice } from "@reduxjs/toolkit";
import { AuthState } from "./types";
import { login } from "./actions";
import "./listener";
import { appSession } from "@/shared/lib/storage";

const initialState = (): AuthState => ({
  user: appSession.getItem() || null,
  loading: "idle",
});

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  selectors: {
    selectIsAuthenticated: (state) =>
      !!state.user && state.loading !== "pending",
  },

  extraReducers(builder) {
    builder.addCase(login.fulfilled, (state, action) => {
      state.user = action.payload;
      state.loading = "succeeded";
    });
    builder.addCase(login.rejected, (state) => {
      state.user = null;
      state.loading = "failed";
    });
    builder.addCase(login.pending, (state) => {
      state.loading = "pending";
    });
  },
});

export const { selectIsAuthenticated } = authSlice.selectors;
